// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
   apiKey: "AIzaSyAmPTzkqBa01UUuAC9gYKRFdSkb3IlcRCM",
  authDomain: "buynesta.firebaseapp.com",
  projectId: "buynesta",
  storageBucket: "buynesta.firebasestorage.app",
  messagingSenderId: "797975139572",
  appId: "1:797975139572:web:3f832dadf9d425c1697aa1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
